import React, { useCallback, useContext, useState } from 'react';
// import { ModelContext } from '../../../../../../../../Model/ModelContext/ModelContext';
// import { FranvaroContext } from '../../../Context/FranvaroContext/FranvaroContext';
import { useBusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  IBusinessCollectionProps,
  IObjektVy,
  IObjektVyComp,
} from '../../../../../../../Types/ObjektVy';
import EDList from '../../../../../../../BaseComponents/List/EDList';
import {
  UserQuery_node_TEDSYSUser,
  UserQuery_node_TEDSYSUser__Associations_Franvaro_All,
} from '../../Queries/_QueryTypes/UserQuery';
import FranvaroAddDialog from '../FranvaroAddDialog/FranvaroAddDialog';
import { FranvaroContext } from '../../Context/FranvaroContext/FranvaroContext';
import FranvaroListItem from '../FranvaroListItem/FranvaroListItem';
import EDDialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { mergeBusinessDataFormValues } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';

interface IProps extends IBusinessCollectionProps {}

export const FranvaroViewComp: React.FC<IProps> = props => {
  const franvaroContext = useContext(FranvaroContext);
  const formContext = useBusinessDataFormContext<UserQuery_node_TEDSYSUser>();

  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [removeFranvaroID, setRemoveFranvaroID] = useState<string>();

  const franvaroPerioder =
    formContext?.formState.currentValues?._Associations?.Franvaro_All ?? [];

  const onEditClick = useCallback(
    (franvaro: UserQuery_node_TEDSYSUser__Associations_Franvaro_All) => () => {
      franvaroContext.setEditFranvaro(franvaro);
      franvaroContext.setFranvaroReservID(
        franvaro._Associations?.Reserv?.id ?? ''
      );
      franvaroContext.setRegisterFranvaroDialogOpen(true);
    },
    [franvaroContext]
  );

  const deleteClick = useCallback(
    (franvaro: UserQuery_node_TEDSYSUser__Associations_Franvaro_All) => () => {
      setConfirmDialogOpen(true);
      setRemoveFranvaroID(franvaro.id ?? '');
    },
    []
  );

  return (
    <>
      <EDList
        style={{
          width: '100%',
        }}
        testId="absence-list"
      >
        {franvaroPerioder && franvaroPerioder.length > 0 ? (
          franvaroPerioder?.map((franvaro, index) => {
            return (
              <FranvaroListItem
                key={index}
                franvaro={franvaro}
                index={index}
                isAuto={franvaro.AUTOSKAPAD ?? false}
                level={franvaro.AUTOSKAPAD_LEVEL ?? 0}
                pointer
                onEditClick={onEditClick(franvaro)}
                onDeleteClick={deleteClick(franvaro)}
              />
            );
          })
        ) : (
          <EDTypography>Det finns ingen frånvaro registrerad</EDTypography>
        )}
      </EDList>
      <EDDialog
        footerActions={[
          {
            label: 'Avbryt',
            onClick: () => {
              formContext?.formStateDispatch({
                type: 'CANCEL',
              });
              setConfirmDialogOpen(false);
              setRemoveFranvaroID(undefined);
            },
          },
          {
            label: 'Ta bort',
            onClick: () => {
              if (!removeFranvaroID) {
                setConfirmDialogOpen(false);
                setRemoveFranvaroID(undefined);
                return;
              }
              const newValues: FormUpdateAssociatonType[] = [
                {
                  associationName: 'Franvaro',
                  id: removeFranvaroID,
                  operation: 'Delete_Values',
                },
              ];

              formContext?.saveForm(
                mergeBusinessDataFormValues(
                  getFormUpdateValue(newValues, formContext.data ?? {}),
                  formContext.formState.values ?? {}
                ),
                () => {
                  setConfirmDialogOpen(false);
                  setRemoveFranvaroID(undefined);
                }
              );
            },
            buttonProps: {
              disabled:
                formContext?.formState.loading || formContext?.mutationLoading,
            },
          },
        ]}
        title="Bekräfta borttag"
        open={confirmDialogOpen}
      >
        <EDTypography>
          Är du säker på att du vill ta bort denna Frånvaroperiod?
        </EDTypography>
      </EDDialog>

      <FranvaroAddDialog id={franvaroContext.editFranvaro?.id ?? ''} />
    </>
  );
};

const FranvaroComp: IObjektVyComp = {
  caption: '',
  comp: (props: IProps) => <FranvaroViewComp {...props} />,
};

export const FranvaroView: IObjektVy = {
  type: 'ObjektVy',
  id: '',
  info: {},
  def: () => FranvaroComp,
};
